module.exports = __webpack_public_path__ + "static/media/appx_icon.2fab5735.svg";